import { forwardRef, type TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helpText?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helpText, id, rows = 3, className = '', ...props }, ref) => {
    const textareaId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

    return (
      <div className={className}>
        {label && (
          <label htmlFor={textareaId} className="block text-sm font-medium text-surface-700 mb-1">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          rows={rows}
          className={[
            'block w-full rounded-lg border bg-white px-3 py-2 text-sm transition-colors',
            'focus:outline-none focus:ring-2 focus:border-transparent',
            error
              ? 'border-danger-500 focus:ring-danger-500'
              : 'border-surface-300 focus:ring-primary-500',
            'disabled:bg-surface-50 disabled:text-surface-500 disabled:cursor-not-allowed',
          ].join(' ')}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-danger-600">{error}</p>}
        {helpText && !error && <p className="mt-1 text-sm text-surface-500">{helpText}</p>}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';
